module.exports = __webpack_public_path__ + "img/KSC00942.e17d597f.jpg";